<template>
	<div class="solve">
		<div class="solonlogy-top">
			<img src="../../static/img/casetoop.jpg"/>
		</div>
		<div class="sol-detail">
			<div class="sol-top-top">
				<h4>{{sol}}</h4>
				<div class="sol-line">	
				</div>
			</div>
			<div class="solinfo" v-html="content">
				
           </div>
		</div>
	</div>
</template>

<script>
	export default{
		name : 'case',
		data () {
			return {
				sol :'',
				chalid : 0,
				content : '',
			}
		},
		mounted(){
			this.getID();
			this.getnews();
		},
		methods : {
			getID(){
				this.chalid = this.$route.params.ID
			},
			getnews(){
      			var that = this;
      			var nowtable = this.tab;
     				this.$http.post('http://www.gd-sc.net:9094',{table : 'protools'},{emulateJSON: true}).then((response) => {
     				for(var i =0 ; i < response.body.recordset.length ; i++){
     					if(this.chalid==response.body.recordset[i].id){
     						this.sol = response.body.recordset[i].protit;
     						this.content = response.body.recordset[i].procontent;
     					}
     				}
			        
			      })
     				this.$http.post('http://www.gd-sc.net:9094',{table : 'Tabtit'},{emulateJSON: true}).then((response) => {
			        for(var i = 0; i<response.body.recordset.length ; i++){
			        	if(response.body.recordset[i].Remark == 'Tabtitp'){
			        		taball.push(response.body.recordset[i])
			        	}
			        }
			        this.lijudge = taball[0].Tabtit;
			        this.navli = taball;
			      })
     			},
		},
	}
</script>

<style>
	.solve{
		width: 100%;
		position: relative;
		clear: both;
		overflow: hidden;
	}
	.sol-detail{
		width: 80%;
		margin: 60px auto;
		position: relative;
		clear: both;
		text-align: left;		
	}
	.sol-line{
		width: 25px;
		height: 3px;
		position: absolute;
		background: #e01313;
		border-radius: 4px;
		top: 8px;
	}	
		.com-tit{
		width: 40%;
		position: absolute;
		clear: both;
		z-index: 3;
		top: 12vw;
	    left: 11vw;
	    text-align: left;
	    font-size: 22px;
	    color: #fff;
	}
	.com-tit img {
	    width: 4% !important;
	    margin-right: 23px;
	}
	.com-tit p{
		margin-top: 20px;
		font-size: 14px;
		line-height: 28px;
	}
	.com-tit b{
		font-size: 25px;
	    position: relative;
	    top: 3px;
	}
	.sol-top-top{
		width: 100%;
		border-bottom: 1px solid #ddd;
		position: relative;
		padding-bottom: 10px;
	}
	.sol-detail h4{
		font-weight: 700;
		margin-left: 50px;
		font-size: 22px;
	}	
	.solonlogy-top img{
		width: 100%;
	}
	.solinfo{
		position: relative;
		clear: both;
		padding: 2%;
	}
	.solinfo .redbg{
		font-weight: bold;
		color: red;
		line-height: 10px;
	}
	.solinfo p{
		color: #666666;
		line-height: 35px;
		margin: 20px auto;
		font-size: 16px;
		text-indent:2em;
	}
	.solinfo img{
		text-align: center;
	}
	.sol-singleimg{
		text-align: center;
		position: relative;
	}
	.sol-singleimg img{
		
	}
	.sol-detail h4.small-tit{
		text-align: center;
		width: 500px;
		margin: 50px auto 0;
		position: relative;
		color: #0066ef ;
		font-weight: 500;
		margin-bottom: 30px;
	}
	.solinfo p b{
		color: red;
	}
	.solinfo p.ggzyp{
		display: inline-block;
		width: 49%;
		position: relative;
		clear: both;
		margin: 10px 0;
	}
	.gcleft{
		float: right;
		width: 56%;
		margin-bottom: 60px;
	}
	.gcright{
		float: left;
	}
	.gcright img{
		float: left;
		width: 100%;
	}
</style>


// WEBPACK FOOTER //
// src/components/engineerings.vue